import { FC } from 'react'
import { usePerson } from 'hooks'
import { PeopleListCard } from 'components'

type ResponsiblePartyProps = {
    responsiblePersonId: any
    label?: string
}

const ResponsibleParty: FC<ResponsiblePartyProps> = (props) => {
    const { responsiblePersonId, label = 'ResponsibleParty' } = props

    const { data: responsiblePartyData, isLoading } = usePerson(
        responsiblePersonId,
        Boolean(responsiblePersonId),
    )

    return (
        <PeopleListCard
            data={responsiblePartyData ? [responsiblePartyData] : undefined}
            isLoading={isLoading}
            label={label}
            enableSearch={false}
            showMore={false}
        />
    )
}

export default ResponsibleParty
